const DashboardPassportItemFields = {
  assignmentId: "assignmentId",
  assignmentStatus: "assignmentStatus",
  nameOfContact: "contact",
  additionalDocuments: "docs", 
  CPNWSpecificRequirements: "CPNWResult", 
  healthcareSiteSpecificRequirement: "HCResult",
  educationSiteSpecificRequirements: "EDResult", 
  backgroundCheck: "BackgroundCheckResult", 
  watchReports: "WatchCheckResult",  
  oig: "OIGResult",
  sam: "SAMResult",
  userContactType: "TypeContact",
};

export default DashboardPassportItemFields;
